import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Authentication guard that protects routes from unauthorized access.
 * 
 * @description
 * This guard verifies if a user is authenticated before allowing access to protected routes.
 * If the user is not authenticated, they will be redirected to the login page, and the
 * attempted URL will be stored for post-login redirection.
 * 
 * @example
 * ```typescript
 * const routes: Routes = [{
 *   path: 'protected',
 *   component: ProtectedComponent,
 *   canActivate: [authGuard]
 * }];
 * ```
 * 
 * @returns {boolean | UrlTree} True if user is authenticated, otherwise a UrlTree to the login page
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
    return true;
  }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = this.router.url;
  
  // Redirect to login page
    return this.router.createUrlTree(['/auth/login']);
  }
}
